import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router, UrlTree } from '@angular/router';
import { CurafidaAuthService } from '../authentication/curafida-auth.service';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';
import { UserRoles } from '../user/entities/user-roles';

export const configurationGuard: CanActivateFn = () => {
    const router = inject(Router);
    const splashScreenStateService = inject(SplashScreenStateService);
    const authService = inject(CurafidaAuthService);

    if (authService.getSession().user.roles.includes(UserRoles.CATALOG_MANAGER)) {
        return true;
    }
    const urlTree: UrlTree = router.parseUrl('/member/home');
    splashScreenStateService.stop();
    return new RedirectCommand(urlTree, { skipLocationChange: true });
};
